import { useEffect, useState } from "react";
import { getRanking } from "../services/api";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "../styles/ranking.css";
import React from "react";

const categoriasCaballeros = ["Suma8", "5ta", "6ta", "7ma", "8va"];
const categoriasDamas = ["Suma11","6ta","7ma", "8va"];

export default function Ranking() {
  const [genero, setGenero] = useState("Libres");
  const [categoria, setCategoria] = useState("Suma8");
  const [ranking, setRanking] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [expandido, setExpandido] = useState(null);
  const { token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      getRanking(categoria, token).then(res => setRanking(res.data));
    }
  }, [categoria, token]);

  // Filtrado por género y búsqueda
  let rankingFiltrado = ranking.filter(j => j.genero === genero);
  if (busqueda.trim() !== "") {
    rankingFiltrado = rankingFiltrado.filter(j =>
      j.nombre.toLowerCase().includes(busqueda.toLowerCase())
    );
  }

  return (
    <div className="ranking-apc-container">
      <h1 className="ranking-apc-title">RANKING</h1>
      <div className="ranking-apc-tabs">
        <button
          className={genero === "Libres" ? "active" : ""}
          onClick={() => {
            setGenero("Libres");
            setCategoria("Suma8");
          }}
        >
          LIBRES
        </button>
        <button
          className={genero === "Damas" ? "active" : ""}
          onClick={() => {
            setGenero("Damas");
            setCategoria("6ta");
          }}
        >
          DAMAS
        </button>
      </div>
      <div className="ranking-apc-categorias">
        {(genero === "Libres" ? categoriasCaballeros : categoriasDamas).map(cat => (
          <button
            key={cat}
            className={categoria === cat ? "active" : ""}
            onClick={() => setCategoria(cat)}
          >
            {cat}
          </button>
        ))}
      </div>
      <div className="ranking-apc-busqueda">
        <input
          type="text"
          placeholder="Buscar jugador"
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
        />
        <span role="img" aria-label="buscar">🔍</span>
      </div>
      <table className="ranking-apc-table">
        <thead>
          <tr>
            <th>Detalles</th>
            <th>Puesto</th>
            <th>Jugador</th>
            <th>Ciudad</th>
            <th>Puntos</th>
          </tr>
        </thead>
        <tbody>
          {rankingFiltrado.map((j, i) => (
            <React.Fragment key={j.id}>
              <tr>
                <td>
                  <button onClick={() => setExpandido(expandido === j.id ? null : j.id)}>
                    {expandido === j.id ? "▲" : "▼"}
                  </button>
                </td>
                <td>{i + 1}</td>
                <td>{j.nombre}</td>
                <td>{j.ciudad || "-"}</td>
                <td>{j.puntos}</td>
              </tr>
              {expandido === j.id && (
  <tr>
    <td colSpan={6}>
      <div>
        <strong>Puntos por fecha:</strong>
        <table style={{ width: "100%", marginTop: "0.5rem" }}>
          <thead>
            <tr>
              <th>1ra</th>
              <th>2da</th>
              <th>3ra</th>
              <th>4ta</th>
              <th>5ta</th>
              <th>6ta</th>
              <th>7ma</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{j.puntos_fecha1 || 0}</td>
              <td>{j.puntos_fecha2 || 0}</td>
              <td>{j.puntos_fecha3 || 0}</td>
              <td>{j.puntos_fecha4 || 0}</td>
              <td>{j.puntos_fecha5 || 0}</td>
              <td>{j.puntos_fecha6 || 0}</td>
              <td>{j.puntos_fecha7 || 0}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </td>
  </tr>
)}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      <button onClick={() => navigate(-1)} style={{ marginTop: "1rem" }}>
        Volver atrás
      </button>
    </div>
  );
}